/**
 * Which games' tutorials a child has seen (2026-11-03), so each one plays once
 * per device. Saved in localStorage beside the scores; "How to play" on a
 * game's difficulty screen forgets it, to show it again.
 */
const keyFor = (language) => `KZ_${language}_TutorialsSeen`;

const read = (storage, language) => {
  try {
    const list = JSON.parse(storage.getItem(keyFor(language)) ?? "[]");
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
};

export const hasSeenTutorial = (game, language, storage = localStorage) => read(storage, language).includes(game);

export const markTutorialSeen = (game, language, storage = localStorage) => {
  const list = read(storage, language);
  if (!list.includes(game)) storage.setItem(keyFor(language), JSON.stringify([...list, game]));
};

export const forgetTutorial = (game, language, storage = localStorage) => {
  storage.setItem(keyFor(language), JSON.stringify(read(storage, language).filter((g) => g !== game)));
};
